export const APP_ENV = process.env.NEXT_PUBLIC_APP_ENV as string;

export const API_URL = process.env.NEXT_PUBLIC_API_URL as string;
export const API_REQUEST_TIMEOUT_MS = process.env.NEXT_PUBLIC_API_REQUEST_TIMEOUT_MS
	? +process.env.NEXT_PUBLIC_API_REQUEST_TIMEOUT_MS
	: undefined;

export const HOST_URL = process.env.NEXT_PUBLIC_HOST_PRODUCTION as string;
export const HOME_REDIRECT_URL = process.env.NEXT_PUBLIC_HOME_REDIRECT_URL ?? 'http://localhost:4200';
export const LINKING_APP_LINK = process.env.NEXT_PUBLIC_LINKING_URL as string;
export const DEEP_LINK_PROTOCOL = process.env.NEXT_PUBLIC_DEEP_LINK_PROTOCOL as string;
export const DASHBOARD_URL = process.env.NEXT_PUBLIC_WEBAPP_URL as string;
export const HOME_PAGE_URL = process.env.NEXT_PUBLIC_HOME_PAGE_URL as string;

export const STRIPE_PUBLISHABLE_KEY = process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY as string;

export const ANDROID_PACKAGE_NAME = process.env.NEXT_PUBLIC_ANDROID_PACKAGE_NAME as string;
export const ANDROID_SHA256_CERT_FINGERPRINTS = process.env.NEXT_PUBLIC_ANDROID_SHA256_CERT_FINGERPRINTS as string;

export const APPLE_TEAM_ID = process.env.NEXT_PUBLIC_APPLE_TEAM_ID as string;
export const APPLE_BUNDLE_ID = process.env.NEXT_PUBLIC_APPLE_BUNDLE_ID as string;

export const GOOGLE_API_KEY = process.env.NEXT_PUBLIC_GOOGLE_API_KEY as string;
export const GOOGLE_API_CLIENT_ID = process.env.NEXT_PUBLIC_GOOGLE_API_CLIENT_ID as string;
export const RECAPTCHA_V2_SITE_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_V2_SITE_KEY as string;
export const RECAPTCHA_V3_SITE_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_V3_SITE_KEY as string;
